export const environment = {
  production: true,
  appName: 'Payperclip Coming Web',
  appLaunchDate:new Date('01/01/2023'),
  appGoogleApiKey:"6LcRGCIjAAAAAHxM4h8M_4mgyPM1LaEYCLzWH4mq"
};
